//export var codeUrl="http://maoyp.natapp4.cc"
//export var codeUrl="https://park.natapp4.cc"
//export var codeUrl="https://www.test.51zhykj.com"
//export var codeUrl="https://www.parking.52zhysq.com"
//export var codeUrl="https://www.51zhykj.com"//衢州
export const codeUrl=`${window.location.protocol}//${window.location.host}`
const SYSTEM_CONFIG={
    COMMON:{
        PLATFORM_NAME:'智慧城市车辆静态交通运管服务平台',
        LOGO_NAME:'城市停车平台',
        BERTH_LIST_VIDEO_FIELD:false,//高位视频编号
        ORDER_SEARCH_PLACE_TIME:false//订单记录/下单时间
    },
  
    JSS:{
        PLATFORM_NAME:'积石山县智慧停车管理平台',
        LOGO_NAME:'积石山智慧停车平台',
        BERTH_LIST_VIDEO_FIELD:false,//高位视频编号
        ORDER_SEARCH_PLACE_TIME:true//订单记录/下单时间
    },
    XH:{
        PLATFORM_NAME:'夏河县智慧停车管理平台',
        LOGO_NAME:'夏河智慧停车平台',
        BERTH_LIST_VIDEO_FIELD:false,//高位视频编号
        ORDER_SEARCH_PLACE_TIME:false//订单记录/下单时间
    },
    DGWJ:{
        PLATFORM_NAME:'智慧城市车辆静态交通运管服务平台',
        LOGO_NAME:'城市停车平台',
        BERTH_LIST_VIDEO_FIELD:true,//高位视频编号
        ORDER_SEARCH_PLACE_TIME:false//订单记录/下单时间
    }
   
}
export default{
    ...SYSTEM_CONFIG.COMMON
}
